<div class="layout-topbar">
  @let config = (config$ | async)!;
  <div class="topbar-left">
    @let user = (user$ | async)!;
    <a tabindex="0" class="menu-button p-trigger" (click)="toggleSidebarMode()">
      <i [class]="isCompact(config) ? 'fa fa-chevron-right' : 'fa fa-chevron-left'"> </i>
    </a>
    <span class="topbar-separator my-2"></span>
    <app-breadcrumb></app-breadcrumb>
    <div class="grow"></div>

    @if (isUserInMaster && haveUserReadOnlyRoleForMasterData(user)) {
      <span class="mr-6 flex items-center gap-2">
        <i>{{ 'general.readOnly' | translate }}</i>
        <fa-icon [icon]="faEye"></fa-icon>
      </span>
    }

    @if (loadedWikiPage) {
      <p-button (onClick)="openWiki()" class="pr-2" [loading]="loadingWiki()" size="small">
        <ng-template #icon>
          <fa-icon [icon]="faQuestion"></fa-icon>
        </ng-template>
        <ng-template #loadingicon>
          <fa-icon [icon]="faSpinner" animation="spin"></fa-icon>
        </ng-template>
      </p-button>
    }

    @if (showEnvironmentTile) {
      <div
        class="mx-4 flex items-center justify-center rounded-full px-3 py-2 text-center text-xs font-bold tracking-wide shadow-sm ring-1 ring-black/10 ring-inset"
        [class]="environmentColorClasses"
      >
        {{ environment | uppercase }}
      </div>
    }

    <img class="mobile-logo" [src]="logoSrc" alt="RGS+" />
  </div>

  <app-sidebar></app-sidebar>
  <div class="layout-mask modal-in"></div>

  <div class="topbar-right">
    <ul class="topbar-menu">
      <li class="profile-item">
        <a tabindex="0" class="cursor-pointer" (click)="profilePopover.toggle($event)">
          <p-avatar [label]="this.username" shape="circle" class="mt-1 mr-2 ml-2"></p-avatar>
          <span class="profile-name">{{ license | titlecase }}</span>
        </a>

        <p-popover #profilePopover>
          <ul class="m-0 w-full list-none p-0 sm:w-[12rem]">
            <li>
              <a
                pRipple
                class="transition-duration-150 hover:bg-surface-100 flex cursor-pointer items-center rounded p-2 transition-colors"
                (click)="onProfileButtonClick(); profilePopover.toggle(false)"
              >
                <i class="fa fa-user mr-4"></i>
                <span class="flex flex-col">
                  <span class="font-semibold">{{ 'topbar.profile' | translate }}</span>
                </span>
              </a>
              @if (!isKibUser) {
                <a
                  (click)="notificationsSidebar.notificationsSidebarVisible = true; profilePopover.toggle(false)"
                  pRipple
                  class="transition-duration-150 hover:bg-surface-100 flex cursor-pointer items-center rounded p-2 transition-colors"
                >
                  <i class="fa fa-inbox mr-4" pBadge [value]="(notesLength$ | async) + ''"></i>
                  <span class="flex flex-col">
                    <span class="font-semibold">{{ 'topbar.notifications' | translate }}</span>
                  </span>
                </a>
              }

              @if (!isKibUser) {
                <a
                  (click)="showTasksSidebar(); profilePopover.toggle(false)"
                  pRipple
                  class="transition-duration-150 hover:bg-surface-100 flex cursor-pointer items-center rounded p-2 transition-colors"
                >
                  <i class="fa fa-book mr-4" pBadge [value]="(tasksLength$ | async) + ''"></i>
                  <span class="flex flex-col">
                    <span class="font-semibold">{{ 'topbar.reports' | translate }}</span>
                  </span>
                </a>
              }

              @if (!isKibUser && licenses && licenses.length > 1) {
                <a
                  (click)="licensesPopover.toggle($event, targetEl)"
                  pRipple
                  class="transition-duration-150 hover:bg-surface-100 flex cursor-pointer items-center rounded p-2 transition-colors"
                >
                  <i class="fa fa-id-card mr-4"></i>
                  <span class="flex flex-col" #targetEl>
                    <span class="font-semibold">{{ 'topbar.licentie' | translate }}</span>
                  </span>
                </a>
              }

              <p-popover #licensesPopover>
                <ul
                  class="m-0 w-full list-none p-0 pr-2 pl-2"
                  [style]="{ 'min-width': '10em', 'max-height': '50vh', 'overflow-y': 'auto' }"
                >
                  @for (_license of licenses; track _license) {
                    <li
                      class="mb-2 flex w-full items-center justify-start rounded border border-transparent p-0 last:mb-0"
                      [class.border-neutral-700]="_license === license"
                    >
                      <a
                        pRipple
                        class="transition-duration-150 hover:bg-surface-100 flex w-full cursor-pointer items-center justify-start rounded p-2 pl-4 transition-colors"
                        (click)="changeLicense(_license); licensesPopover.toggle(false); profilePopover.toggle(false)"
                      >
                        <i class="fa fa-building mr-4"></i>
                        <span class="flex flex-col">
                          <span class="font-semibold">{{ _license | titlecase }}</span>
                        </span>
                      </a>
                    </li>
                  }
                </ul>
              </p-popover>

              <a
                pRipple
                class="transition-duration-150 hover:bg-surface-100 flex cursor-pointer items-center rounded p-2 transition-colors"
                (click)="logout(); profilePopover.toggle(false)"
              >
                <i class="fa fa-power-off mr-4"></i>
                <span class="flex flex-col">
                  <span class="font-semibold">{{ 'topbar.logout' | translate }}</span>
                </span>
              </a>
            </li>
          </ul>
        </p-popover>
      </li>
    </ul>
  </div>
</div>
<app-notifications-sidebar #notificationsSidebar></app-notifications-sidebar>
<app-tasks-sidebar #tasksSidebar></app-tasks-sidebar>

<p-toast
  key="task-running"
  position="bottom-right"
  [baseZIndex]="1200"
  [autoZIndex]="false"
  [style]="{ 'z-index': 1200 }"
>
  <ng-template let-message #message>
    <div class="m-0 grid grid-cols-12 gap-4 p-0">
      <div class="col-span-12 m-0 mt-2 p-0">
        <span class="flex items-center justify-start pb-2">
          <h4 class="m-0 p-0 text-xl">
            <fa-icon [icon]="faCircleNotch" animation="spin" size="lg" class="mr-2"></fa-icon> {{ message.summary }}
          </h4>
        </span>
        <p>{{ message.detail }}</p>
      </div>
    </div>
  </ng-template>
</p-toast>
<p-toast
  key="task-complete"
  position="bottom-right"
  [baseZIndex]="1201"
  [autoZIndex]="false"
  [style]="{ 'z-index': 1201 }"
>
  <ng-template let-message #message>
    <div class="m-0 grid grid-cols-12 gap-4 p-0">
      <div class="col-span-12 m-0 mt-2 p-0">
        <span class="flex items-center justify-between pb-2">
          <h4 class="m-0 p-0 text-xl">
            <fa-icon [icon]="faCheck" size="lg" class="mr-2"></fa-icon> {{ message.summary }}
            <i>
              <a (click)="goToTask()" [style]="{ 'text-decoration': 'underline', color: 'black', cursor: 'pointer' }">
                {{ 'reportTasks.seeReport' | translate }} <fa-icon [icon]="faArrowRight" class="mr-2"> </fa-icon
              ></a>
            </i>
          </h4>
        </span>
        <p>{{ message.detail }}</p>
      </div>
    </div>
  </ng-template>
</p-toast>
<p-toast key="task-fail" position="bottom-right" [baseZIndex]="1202" [autoZIndex]="false" [style]="{ 'z-index': 1202 }">
</p-toast>
